import { render, staticRenderFns } from "./EditarEtapaPeriferico.vue?vue&type=template&id=0b2b11d8"
import script from "./EditarEtapaPeriferico.vue?vue&type=script&lang=js"
export * from "./EditarEtapaPeriferico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports